import { Lock, ArrowLeft, ArrowRight, Send, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Calcola la classe CSS per le pill degli step, eliminando il ternario annidato.
 */
function pillClass(index, currentStep) {
  if (index === currentStep) return "bg-[#163321] text-white border-[#163321]";
  if (index < currentStep) return "bg-[#163321]/10 text-[#163321] border-[#163321]/20";
  return "bg-white text-[#4A5E51] border-[#E5E2DB]";
}

/**
 * StepProgress - Barra di avanzamento + step pills condivisa tra tutti i questionari.
 */
export function StepProgress({ steps, currentStep, onStepClick, progress, testIdPrefix }) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-[#4A5E51]">
          Passo {currentStep + 1} di {steps.length}: {steps[currentStep]}
        </span>
        <span className="text-xs text-[#4A5E51]">{Math.round(progress)}%</span>
      </div>
      <div className="h-1.5 bg-[#E5E2DB] rounded-full overflow-hidden">
        <div
          className="h-full bg-[#163321] rounded-full progress-fill"
          style={{ width: `${progress}%` }}
          data-testid={`${testIdPrefix}-progress`}
        />
      </div>
      <div className="flex gap-1.5 mt-3 flex-wrap">
        {steps.map((s, i) => (
          <button
            key={s}
            onClick={() => onStepClick(i)}
            className={`text-[10px] px-2.5 py-1 rounded-full border transition-all ${pillClass(i, currentStep)}`}
            data-testid={`${testIdPrefix}-pill-${i}`}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}

/**
 * FormNavigation - Pulsanti Indietro / Avanti / Invia condivisi.
 */
export function FormNavigation({
  step,
  totalSteps,
  onPrev,
  onNext,
  onSubmit,
  submitting,
  canSubmit,
  prevLabel = "Indietro",
  testIdPrefix,
}) {
  return (
    <>
      <div className="flex items-center gap-2 justify-center mb-6 text-xs text-[#4A5E51]">
        <Lock className="w-3 h-3" />
        <span>I tuoi dati sono al sicuro e protetti</span>
      </div>
      <div className="flex items-center justify-between">
        <Button
          variant="outline"
          onClick={onPrev}
          className="rounded-full px-6 h-11 border-[#E5E2DB] text-[#163321] hover:bg-[#F5F4F0] text-sm font-medium"
          data-testid={`${testIdPrefix}-prev-btn`}
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> {prevLabel}
        </Button>
        {step < totalSteps - 1 ? (
          <Button
            onClick={onNext}
            className="rounded-full px-6 h-11 bg-[#163321] text-white hover:bg-[#224A32] text-sm font-medium"
            data-testid={`${testIdPrefix}-next-btn`}
          >
            Avanti <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        ) : (
          <Button
            onClick={onSubmit}
            disabled={submitting || !canSubmit}
            className="rounded-full px-6 h-11 bg-[#D97B58] text-white hover:bg-[#C06A48] text-sm font-medium disabled:opacity-50"
            data-testid={`${testIdPrefix}-submit-btn`}
          >
            {submitting ? (
              <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Invio...</>
            ) : (
              <><Send className="w-4 h-4 mr-2" /> Invia Richiesta</>
            )}
          </Button>
        )}
      </div>
      <div className="mt-8 text-center">
        <p className="text-xs text-[#4A5E51] italic">
          &quot;Parlerai con un consulente reale, non con un sistema automatico&quot;
        </p>
      </div>
    </>
  );
}
